import { useState } from 'react'

import { Dialog, Field, Layout, Text, TextArea } from '@loadsmart/miranda-react'

// The backend rejects descriptions longer than 500 characters.
const MAX_LENGTH = 500

interface PerformanceReportFeedbackDialogProps {
  open: boolean
  reportLabel: string
  isSending: boolean
  onCancel: () => void
  onSend: (description: string) => void
}

export default function PerformanceReportFeedbackDialog({
  open,
  reportLabel,
  isSending,
  onCancel,
  onSend,
}: PerformanceReportFeedbackDialogProps) {
  const [description, setDescription] = useState('')

  const handleSend = () => {
    onSend(description)
    setDescription('')
  }

  const handleClose = () => {
    onCancel()
    setDescription('')
  }

  const isDisabled = isSending || description.trim().length === 0

  return (
    <Dialog open={open} size="small" variant="neutral" onClose={handleClose}>
      <Dialog.Header>
        Send feedback
        <Dialog.Close />
      </Dialog.Header>
      <Dialog.Body>
        <Layout.Stack gap="spacing-4">
          <Text variant="body-md" color="color-text-secondary">
            {reportLabel}
          </Text>
          <Field>
            <Field.Label id="feedbackLabel">Your feedback</Field.Label>
            <TextArea
              aria-labelledby="feedbackLabel"
              rows={6}
              maxLength={MAX_LENGTH}
              placeholder="Share what's working well, what could be improved, or what you'd like to see in future reports."
              value={description}
              onInput={event => {
                const element = event.target as unknown as HTMLTextAreaElement
                setDescription(element.value.slice(0, MAX_LENGTH))
              }}
            />
            <Text variant="body-sm" color="color-text-tertiary">
              {description.length}/{MAX_LENGTH}
            </Text>
          </Field>
        </Layout.Stack>
      </Dialog.Body>
      <Dialog.Footer></Dialog.Footer>
      <Dialog.Actions>
        <Dialog.ActionTertiary onClick={handleClose}>Cancel</Dialog.ActionTertiary>
        <Dialog.ActionPrimary onClick={handleSend} disabled={isDisabled} loading={isSending}>
          Send feedback
        </Dialog.ActionPrimary>
      </Dialog.Actions>
    </Dialog>
  )
}
